"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var Op_1 = require("./Op");
var Iterator = /*#__PURE__*/function () {
  function Iterator(ops) {
    _classCallCheck(this, Iterator);
    this.ops = ops;
    this.index = 0;
    this.offset = 0;
  }
  return _createClass(Iterator, [{
    key: "hasNext",
    value: function hasNext() {
      return this.peekLength() < Infinity;
    }
  }, {
    key: "next",
    value: function next(length) {
      if (!length) {
        length = Infinity;
      }
      var nextOp = this.ops[this.index];
      if (nextOp) {
        var offset = this.offset;
        var opLength = Op_1["default"].length(nextOp);
        if (length >= opLength - offset) {
          length = opLength - offset;
          this.index += 1;
          this.offset = 0;
        } else {
          this.offset += length;
        }
        if (typeof nextOp["delete"] === 'number') {
          return {
            "delete": length
          };
        } else {
          var retOp = {};
          if (nextOp.attributes) {
            retOp.attributes = nextOp.attributes;
          }
          if (typeof nextOp.retain === 'number') {
            retOp.retain = length;
          } else if (_typeof(nextOp.retain) === 'object' && nextOp.retain !== null) {
            // offset should === 0, length should === 1
            retOp.retain = nextOp.retain;
          } else if (typeof nextOp.insert === 'string') {
            retOp.insert = nextOp.insert.substr(offset, length);
          } else {
            // offset should === 0, length should === 1
            retOp.insert = nextOp.insert;
          }
          return retOp;
        }
      } else {
        return {
          retain: Infinity
        };
      }
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.ops[this.index];
    }
  }, {
    key: "peekLength",
    value: function peekLength() {
      if (this.ops[this.index]) {
        // Should never return 0 if our index is being managed correctly
        return Op_1["default"].length(this.ops[this.index]) - this.offset;
      } else {
        return Infinity;
      }
    }
  }, {
    key: "peekType",
    value: function peekType() {
      var op = this.ops[this.index];
      if (op) {
        if (typeof op["delete"] === 'number') {
          return 'delete';
        } else if (typeof op.retain === 'number' || _typeof(op.retain) === 'object' && op.retain !== null) {
          return 'retain';
        } else {
          return 'insert';
        }
      }
      return 'retain';
    }
  }, {
    key: "rest",
    value: function rest() {
      if (!this.hasNext()) {
        return [];
      } else if (this.offset === 0) {
        return this.ops.slice(this.index);
      } else {
        var offset = this.offset;
        var index = this.index;
        var next = this.next();
        var _rest = this.ops.slice(this.index);
        this.offset = offset;
        this.index = index;
        return [next].concat(_rest);
      }
    }
  }]);
}();
exports["default"] = Iterator;